<template>
  <div class="size-finder__tab size-finder__tab--garment-measurements">
    <h4
      v-if="tabContent.paragraphTitle"
      class="size-finder__tab-heading text-body-m-bold"
      v-text="tabContent.paragraphTitle"
    />

    <div
      v-if="tabContent.paragraphContent"
      class="size-finder__tab-paragraph"
      v-html="tabContent.paragraphContent"
    />

    <size-table
      :table-source="activeGuideTable"
      :enable-unit-toggle="enableUnitToggle"
    />

    <div
      v-if="tabContent.fitImage"
      class="size-finder__fit-image-wrapper"
    >
      <responsive-image
        class="size-finder__fit-image"
        :image="tabContent.fitImage"
        :sizes="sizes"
      />
    </div>

  </div>
</template>

<script>
import SizeTable from './size-table'
import ResponsiveImage from '~global/images/responsive-image'
import { values as breakpoints } from '~/config/breakpoints'

export default {
  name: 'GarmentMeasurementsTab',

  components: {
    SizeTable,
    ResponsiveImage,
  },

  props: {
    tabContent: {
      type: Object,
      default: () => ({}),
    },
    enableUnitToggle: {
      type: [Boolean, Object],
      default: true,
    },
  },

  data() {
    return {
      activeGuideTable: '',
    }
  },

  computed: {
    /**
     * Compute responsive image sizes.
     * @returns {String}
    */
    sizes() {
      return `(min-width: ${breakpoints.l}) 510px, 960px`
    },
  },

  mounted() {
    this.getActiveGuide()
  },

  methods: {
    /**
     * Get active size guide table source.
     */
    getActiveGuide() {
      this.activeGuideTable = this.tabContent.tables?.gb || this.tabContent.gettingChangedTable || ''
    },
  },
}
</script>
